<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Block Transport</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
       <v-row justify="center" dense>
          <v-col cols="12" sm="4" md="4">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
            />
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <p><v-icon color="error">*</v-icon><b>Child</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="child"
              :items="child_list"
              item-text="name"
              item-value="lid"
              label="Child"
              outlined
              persistent-hint
              hint="Please Select Child"
              multiple
            />
          </v-col>
          <v-col
            col="12"
            sm="2"
            md="2"
            class="pt-6 mt-6"
            v-if="this.ay && this.child"
          >
            <v-btn color="warning" @click="fetchData()">Fetch</v-btn>
          </v-col>
        </v-row>
       </v-card>
        <br />
       <v-card class="box" v-if="basic_student_data != ''">
       <v-toolbar  flat dense class="toolbar">
        <v-toolbar-title>Student List</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
        <v-data-table
        :headers="headers1"
        :items="basic_student_data"
        :search="search"
        class="elevation-1 mytable"
        dense
        v-if="basic_student_data != ''"
      >
        <template v-slot:[`item.is_blocked_for_transport`]="{ item }">
          <v-switch v-model="item.is_blocked_for_transport"></v-switch>
        </template>
        <template v-slot:[`item.blocked_for_transport_reason`]="{ item }">
         <v-text-field  outlined dense type="text" v-model="item.blocked_for_transport_reason" ></v-text-field>
        </template>
      </v-data-table>
      <center>
        <v-btn
          color="#0f2027"
          v-if="basic_student_data != ''"
          :loading="loader"
          class="button"
          @click="saveData()"
          >Save</v-btn
        >
      </center>
       </v-card>
     

     <!-- <v-card class="box" v-if="query_list.length > 0">
     <v-data-table  :headers="headers" :items="query_list" >
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Queries</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
     </v-data-table>
 </v-card> -->
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      ay_list:[],ay:"",
      child_list:[],child:"",basic_student_data:[],
      headers1: [
      { text: "PRN No.", value: "registration_number" },
      { text: "Roll No.", value: "roll_no" },
      { text: "Name", value: "student_name" },
      { text: "Standard", value: "standard" },
      { text: "Division", value: "division" },
      { text: "Block", value: "is_blocked_for_transport" },
      { text: "Reason", value: "blocked_for_transport_reason" },
    ],
  }),
   methods: {
      saveData() {
      this.loader = true;
      const formData = {
        basic_student_data: this.basic_student_data,
      };
      axios
        .post("/ParentTransport/saveBlockStudentForTransport", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.loader = false;
            this.showSnackbar("#4caf50", "Save successfully");
            this.fetchData();
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.loader = false;
        })
        .finally(() => {
          this.loader = false;
        });
    },
   async fetchData() {
      const formData = {
        learner_id: this.child,
        ay_id: this.ay,
      };
      try {
          const res = await axios.post("/Canteen/blockCanteenFacility", formData)
          if (res.data.flag == "YES") {
            this.basic_student_data = res.data.basic_student_data;
            if(this.basic_student_data.length<=0){
              this.showSnackbar("#b71c1c", "Standard Division Not Mapped For This Academicyear..."); // show snackbar
            }
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
    },
    async onLoad() {
      try {
          const res = await axios.post("/ParentTransport/blockStudentForTransport");
          if (res.data.flag == "YES") {
            this.ay_list=res.data.ay_list
            this.child_list=res.data.learner_list
            this.ay=res.data.curreny_ay
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
.radiospace {
  margin: 1rem !important;
  padding: 0%;
}
.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: left;
}
.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: left;
}
.t-row {
  padding: 1rem i !important;
}
.mytable2 /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.delete-avatar {
  transition: 0.3s;
  border: 1px solid red;
  margin: 0.2rem !important;
}
.delete-avatar:hover {
  background-color: transparent;
}
.delete-v-icon {
  padding-left: 8px;
  padding-top: 1px;
  font-size: 15px;
}
.delete-v-icon:hover {
  color: white;
}
.ay-css {
  margin-top: 15%;
}
</style>
